(() => {
  if (window.vitalDealCountdownReady) return;
  window.vitalDealCountdownReady = true;
  let deals = [];
  const config = document.querySelector('[data-vital-deal-config]');
  try { deals = JSON.parse(config?.textContent || '[]'); } catch {}
  const labels = { ends: config?.dataset.ends || 'DEAL ENDS', days: config?.dataset.days || 'd', hours: config?.dataset.hours || 'h', minutes: config?.dataset.minutes || 'm', seconds: config?.dataset.seconds || 's' };
  const path = value => { try { const u = new URL(value, location.origin); return u.origin === location.origin ? u.pathname.replace(/\/$/, '') : ''; } catch { return ''; } };
  const byURL = new Map(deals.filter(d => d.url && Number.isFinite(Date.parse(d.end))).map(d => [path(d.url), d]));
  function format(milliseconds) {
    const seconds = Math.max(0, Math.ceil(milliseconds / 1000));
    return `${Math.floor(seconds / 86400)}${labels.days} ${String(Math.floor(seconds / 3600) % 24).padStart(2, '0')}${labels.hours} ${String(Math.floor(seconds / 60) % 60).padStart(2, '0')}${labels.minutes} ${String(seconds % 60).padStart(2, '0')}${labels.seconds}`;
  }
  function hydrate() {
    document.querySelectorAll('.recent-card,.vitally-product-card,.ve-product-card').forEach(card => {
      if (card.dataset.dealHydrated) return;
      const link = card.matches('a[href]') ? card : card.querySelector('a[href]');
      const deal = link && byURL.get(path(link.getAttribute('href')));
      if (!deal || Date.parse(deal.end) <= Date.now()) return;
      card.dataset.dealHydrated = 'true';
      const row = document.createElement('div'); row.className = 'vital-deal vital-deal--card'; row.dataset.vitalDealExpiry = deal.end;
      const badge = document.createElement('span'); badge.className = 'vital-deal-badge'; badge.textContent = labels.ends;
      const time = document.createElement('time'); time.className = 'vital-deal-timer'; time.dateTime = deal.end; time.dataset.vitalDealTimer = '';
      row.append(badge, time); (card.querySelector('.tile-copy') || card).append(row);
    });
  }
  function tick() {
    document.querySelectorAll('[data-vital-deal-expiry]').forEach(el => {
      const remaining = Date.parse(el.dataset.vitalDealExpiry) - Date.now();
      const active = Number.isFinite(remaining) && remaining > 0;
      el.hidden = !active;
      if (!active) return;
      const timer = el.querySelector('[data-vital-deal-timer]');
      if (timer) timer.textContent = format(remaining);
    });
  }
  function scan() { hydrate(); tick(); }
  let queued = false;
  const observer = new MutationObserver(records => {
    if (queued || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1))) return;
    queued = true; queueMicrotask(() => { queued = false; scan(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) scan(); });
  document.addEventListener('shopify:section:load', scan);
  scan(); setInterval(() => { if (!document.hidden) tick(); }, 1000);
})();
